import type {
  ModelSettingType,
  SearchPageModelSortType,
  SelfModeType,
} from "../model";

/** 获得模型推荐标签分页 */
export interface IGetRecommendModelTagParams {
  name?: string;
  searchName?: string;
  type: number;
  pageNo: number;
  pageSize: number;
}

/** 创建模型合集 */
export interface ICreateModelCollectionParams {
  collectionName: string;
  collectionIntro: string;
  collectionOpenStatus: boolean;
  tags: string[];
  coverImgFileId?: string;
  coverImgUrl?: string;
}

/** 获得模型合集分页 */
export interface IGetModelCollectionPageParams {
  pageNo: number;
  pageSize: number;
  collectionName?: string;
  modelId?: string;
  userId?: string;
}

/** 获得模型合集(不分页) 获取所有 */
export interface IGetModelCollectionListParams {
  collectionName?: string;
  modelId?: string;
}

/** 爬取第三方链接网站信息 */
export interface IGetModelOriginalInfoParams {
  original: string;
}

/** 获得模型分页 */
export interface IGetModelPageParams {
  modelId?: string;
  modelName: number;
  originalityType?: number;
  status?: number;
  open?: string;
  classificationId?: string;
  licenseType?: number;
  nsfw: string;
  pageNo: number;
  pageSize: number;
}

/** 最终步骤：上传模型 */
export interface ICreateModelParams {
  id: String;
  coverImgFileId: String;
  coverImgUrl: String;
  modelName: String;
  originalityType: 1; // 1原创/2改编/3转载; 默认原创;
  originModelId: String;
  originUrl: String;
  // adaptContent: String;
  status: String;
  open: false;
  uploadTime: String;
  classificationId: String;
  licenseType: String;
  modelDetail: String;
  nsfw: Boolean;
  modelPicList: [];
  modelFileList: [];
  modelAttachList: [];
  modelTagList: []; // String[]
  modelSettingInfoVO: Object;
  modelMaterialInfoVOList: [];
  modelCollectionIds: []; // String[]
  modelCollectionInfos: [];
}

// 翻译富文本; (暂无用)
export interface ILanguageTranslateParams {
  sourceLanguage: string;
  targetLanguage: string;
  contents: string;
}

// 收藏模型;
export interface ICollectModelParams {
  modelId: string;
  collectionIds: string[];
}

// 点赞;
export interface ILikeModelParams {
  type: string;
  like: boolean;
  bizId: string;
}

// 获取模型评论;
export interface IGetModelCommentParams {
  modelId: number | string;
  settingId: number | string;
  sortRule: number;
}

// 创建模型评论; /api/v1/model-library-server/library/model-comment/create
export interface ICreateModelCommentParams {
  // id: number | string;
  modelId: number | string;
  content: string;
  rootId?: number | string;
  replyCommentId?: number | string;
  settingId?: number | string;
  score: number;
  picList?: {
    fileId: string;
    fileName: string;
    fileSize: number;
    fileUrl: string;
    fileExt: string;
    extra: any;
  }[];
}

export enum ReportContentType {
  MODEL = "MODEL", // 模型;
  COMMENT = "COMMENT", // 评论;
  USER = "USER", // 用户;
}

// 举报原因类型;
export enum ReasonType {
  MEMBER_INFO_AVATAR_VIOLATION = "MEMBER_INFO_AVATAR_VIOLATION", // 个人信息举报-头像违规
  MEMBER_INFO_NICKNAME_VIOLATION = "MEMBER_INFO_NICKNAME_VIOLATION", // 个人信息举报-昵称违规
  MEMBER_INFO_BIO_VIOLATION = "MEMBER_INFO_BIO_VIOLATION", // 个人信息举报-个人介绍违规
  MEMBER_BEHAVIOR_PORNOGRAPHIC = "MEMBER_BEHAVIOR_PORNOGRAPHIC", // 个人信息举报-色情低俗
  MEMBER_BEHAVIOR_FALSE_INFORMATION = "MEMBER_BEHAVIOR_FALSE_INFORMATION", // 个人信息举报-不实信息
  MEMBER_BEHAVIOR_PERSONAL_ATTACK = "MEMBER_BEHAVIOR_PERSONAL_ATTACK", // 个人信息举报-人身攻击
  MEMBER_BEHAVIOR_BLOODY_VIOLENCE = "MEMBER_BEHAVIOR_BLOODY_VIOLENCE", // 个人信息举报-血腥暴力
  MEMBER_BEHAVIOR_ILLEGAL_LINK = "MEMBER_BEHAVIOR_ILLEGAL_LINK", // 个人信息举报-违法信息外链
  MEMBER_BEHAVIOR_OTHER = "MEMBER_BEHAVIOR_OTHER", // 个人信息举报-其他

  WORK_ILLEGAL_PROHIBITED = "WORK_ILLEGAL_PROHIBITED", // 作品举报-违法违禁
  WORK_ILLEGAL_PLAGIARISM_OF_MY_WORK = "WORK_ILLEGAL_PLAGIARISM_OF_MY_WORK", // 作品举报-盗搬我的作品
  WORK_ILLEGAL_LINK = "WORK_ILLEGAL_LINK", // 作品举报-违法信息外链
  WORK_ILLEGAL_INFRINGEMENT_APPEAL = "WORK_ILLEGAL_INFRINGEMENT_APPEAL", // 作品举报-侵权申诉
  WORK_IRREGULARITY_NOT_ORIGINAL = "WORK_IRREGULARITY_NOT_ORIGINAL", // 作品举报-非原创
  WORK_IRREGULARITY_INCORRECT_REARRANGEMENT = "WORK_IRREGULARITY_INCORRECT_REARRANGEMENT", // 作品举报-改编/转载错误
  WORK_IRREGULARITY_OTHER_IRREGULARITIES = "WORK_IRREGULARITY_OTHER_IRREGULARITIES", // 作品举报-其他不规范行为
  WORK_VIOLATION_PORNOGRAPHIC = "WORK_VIOLATION_PORNOGRAPHIC", // 作品举报-色情低俗
  WORK_VIOLATION_DANGEROUS_BEHAVIOR = "WORK_VIOLATION_DANGEROUS_BEHAVIOR", // 作品举报-危险行为
  WORK_VIOLATION_UNCOMFORTABLE_VIEW = "WORK_VIOLATION_UNCOMFORTABLE_VIEW", // 作品举报-观感不适
  WORK_VIOLATION_BLOODY_VIOLENCE = "WORK_VIOLATION_BLOODY_VIOLENCE", // 作品举报-血腥暴力
  WORK_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH = "WORK_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH", // 作品举报-青少年不良信息
  WORK_VIOLATION_OTHER = "WORK_VIOLATION_OTHER", // 作品举报-其他

  COMMENT_ILLEGAL_PROHIBITED = "COMMENT_ILLEGAL_PROHIBITED", // 评论举报-违法违禁
  COMMENT_ILLEGAL_LINK = "COMMENT_ILLEGAL_LINK", // 评论举报-违法信息外链
  COMMENT_ILLEGAL_INFRINGEMENT_APPEAL = "COMMENT_ILLEGAL_INFRINGEMENT_APPEAL", // 评论举报-侵权申诉
  COMMENT_VIOLATION_PORNOGRAPHIC = "COMMENT_VIOLATION_PORNOGRAPHIC", // 评论举报-色情低俗
  COMMENT_VIOLATION_DANGEROUS_BEHAVIOR = "COMMENT_VIOLATION_DANGEROUS_BEHAVIOR", // 评论举报-危险行为
  COMMENT_VIOLATION_UNCOMFORTABLE_VIEW = "COMMENT_VIOLATION_UNCOMFORTABLE_VIEW", // 评论举报-观感不适
  COMMENT_VIOLATION_BLOODY_VIOLENCE = "COMMENT_VIOLATION_BLOODY_VIOLENCE", // 评论举报-血腥暴力
  COMMENT_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH = "COMMENT_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH", // 评论举报-青少年不良信息
  COMMENT_VIOLATION_OTHER = "COMMENT_VIOLATION_OTHER", // 评论举报-其他
}

// 创建模型举报信息;
export interface ICreateModelReportParams {
  contentType: ReportContentType;
  contentId: string; // 被举报内容ID
  reportedId: string; // 被举报用户ID
  description: string; // 描述
  reason: ReasonType; // 原因
  modelId?: string; // 被举报内容关联的模型ID
  attachments?: {
    type: number; // 传1即是图片
    url: string;
  }[];
}

export interface ICreateModelSettingParams {
  modelId: number;
  settingName: string;
  settingContent: string;
  settingCoverImgFileId: number;
  settingFile: {
    fileId: string;
    fileName?: string;
    fileSize?: number;
    fileUrl: string;
    fileExt?: string;
    extra?: any;
  }[];
  type?: ModelSettingType;
  open?: boolean;
  needMoreColor?: boolean;
  plateInfo: {
    type: number;
    squeezHeadSize: number;
    thickness: number;
    coverImgFileId: number;
    printTime?: number;
    materialList: {
      materialName: string;
      materialColor: string;
      materialWeightInfo?: string;
      materialWeight?: number;
    }[];
  }[];
  settingParam: {
    type: number;
    squeezHeadSize: number;
    thickness: number;
    printTime?: number;
    materialList: {
      materialName: string;
      materialColor: string;
      materialWeight?: number;
    }[];
  }[];
}

export interface GetModelSettingParams {
  listType?: 0 | 1;
  sortType?: 1 | 2; // 1：最新发布,2：最多下载
  type?: 1 | 2 | 3; // 1:FDM|2:RESIN|3:BOTH
  visitMemberId?: string; // 访问的用户ID
}

export interface GetModelPageParams {
  pageNo: number;
  pageSize: number;
  visitMemberId?: string; // 访问的用户ID
}

export interface ModelHandlerParams {
  id: string;
}

export interface TopModelHandlerParams {
  id: string;
  status: boolean; // 是否置顶/是否公开
}

export interface GeSelfModeParams {
  type: SelfModeType;
}

export interface ISearchPageModelsParams {
  pageNo: number;
  pageSize: number;
  classificationId?: string | number;
  keyword?: string | number;
  timeFrame?: string | number; // 时间范围;
  licenseTypes?: string | number; // 授权类型;
  printConfigType?: string | number; // 打印配置类型;
  isMultiColor?: boolean; // 是否多色;
  sortType?: SearchPageModelSortType;
}

// 第三方模型搜索列表;
export interface IThirdPartySearchPageModelsParams {
  keyword: string;
  pageNo: number;
  pageSize: number;
}

/** 模型合集接口 返回的List item 数据 */
export interface IResModelCollectionListItem {
  /* 合集id 后端雪花生成的id(长整型)，接口中的id可能为number/string，只要不修改，无所谓类型，为方便操作，这里记为string */
  id: string;
  /* 合集名称 */
  collectionName: string;
  /* 介绍 */
  collectionIntro: string;
  /* 是否公开 */
  collectionOpenStatus: boolean;
  /* 创建时间 时间戳 */
  createTime: number | null;
  /* 标签 */
  tags: string[] | null;
  /* 模型封面id */
  coverImgFileId: number | null;
  /* 模型封面url */
  coverImgUrl: string | null;
  /* 当前模型是否被收藏 */
  isCollected: boolean | null;
  /* 当前集合是否已被收藏 */
  collectionCollected: boolean | null;
  /* 当前集合是否已被点赞 */
  collectionStarred: boolean | null;
  /* 是否默认合集 */
  isDefault: boolean | null;
  /* 模型数量 */
  countNum: number | null;
  /* 集合点赞数量 */
  collectionStarPeopleCount: number | null;
  /* 集合收藏数量 */
  collectionCollectPeopleCount: number | null;
  /** 合集是否失效 0失效 1有效  */
  collectionAvailable: number | null;
  author: {
    userId: string;
    /** 作者名 */
    nickname: string | null;
    /** 作者头像 */
    authorAvatar: string | null;
  };
  /** 不可见模型数 */
  invalidModelCount: number | null;
  /** 是否敏感 */
  nsfw: boolean | null;
}

/** 模型合集 分页 接口返回数据 */
export interface IResModelCollectionPage {
  code: number;
  msg: string;
  data: {
    total: number;
    list: IResModelCollectionListItem[];
  };
}

/** 模型合集 列表 接口返回数据 */
export interface IResModelCollectionList {
  code: number;
  msg: string;
  data: IResModelCollectionListItem[];
}

/** 模型合集 单个合集 接口返回数据 */
export interface IResModelCollectionItem {
  code: number;
  msg: string;
  data: IResModelCollectionListItem;
}

export interface IRecommendPageModelsParams {
  pageNo: number;
  pageSize: number;
  // 本次请求的seed 用于分页推荐 不传入会生成并返回
  seed?: string;
  preViewTime?: number;
}

interface IFileInfo {
  fileId: number;
  fileName: string;
  fileSize: number;
  fileUrl: string;
  fileExt: string;
  extra: Record<string, any>;
  isCreator: boolean;
  creator?: string;
  createTime?: string;
}

interface IClassificationInfo {
  id: number;
  classificationName: string;
  picUrl: string;
  classificationDesc: string;
  classificationDescPic: string;
  bannerName: string;
  level: number;
  pid: number;
  classificationNameZh: string;
  classificationNameEn: string;
}

interface IAuthorInfo {
  id: number;
  userId: string;
  nickname: string;
  statistics: {
    userFollowCount: number;
    userFollowerCount: number;
    // 其他统计字段...
  };
  followed: boolean;
  self: boolean;
  avatarUrl: string;
  userName: string;
}

interface ISettingInfo {
  id: number;
  modelId: number;
  modelName: string;
  settingName: string;
  settingOutId: string;
  settingContent: string;
  userId: number;
  settingCoverImgFileId: number;
  settingCoverImgUrl: string;
  type: number;
  createTime: string;
  isCreator: boolean;
  loginUserIsCreator: boolean;
  score: number;
  currentScore: number;
  scoreCount: number;
  status: number;
  open: boolean;
  needMoreColor: boolean;
  settingFile: IFileInfo;
  publishTime: string;
  lastUpdateTime: string;
  originalLanguage: string;
  author: IAuthorInfo;
  plateList: Array<{
    id: number;
    modelId: number;
    settingId: number;
    type: string;
    printTime: number;
    printTimeStr: string;
    coverImgFileId: number;
    coverImgUrl: string;
    squeezHeadSize: number;
    thickness: number;
    createTime: string;
    materialList: Array<{
      materialName: string;
      materialColor: string;
      materialWeight: number;
    }>;
  }>;
  statistics: {
    printSettingScore: number;
    printSettingScorePeopleCount: number;
    // 其他统计字段...
  };
}

export interface IModelBaseInfo {
  id: number;
  coverImgFileId: number;
  coverImgUrl: string;
  modelName: string;
  modelId: string;
  originalityType: number;
  originModelId?: number;
  originUrl: string;
  originTitle: string;
  originAuthor: string;
  adaptContent: string;
  status: number;
  open: boolean;
  uploadTime: string;
  updateTime: string;
  publishTime: string;
  lastUpdateTime: string;
  classificationId: number;
  classificationInfos: IClassificationInfo[];
  licenseType: number;
  modelDetail: string;
  nsfw: boolean;
  modelPicList: IFileInfo[];
  commentPicList: IFileInfo[];
  modelFileList: IFileInfo[];
  modelAttachList: IFileInfo[];
  modelTagList: any[];
  settingInfoList: ISettingInfo[];
  modelMaterialInfoVOList: Array<{
    materialName: string;
    materialNum: number;
    materialRemark: string;
  }>;
  statistics: {
    staticsModelReadCount: number;
    staticsModelReadPeopleCount: number;
    // 其他统计字段...
  };
}

interface IRecommendPageResult {
  list: IModelBaseInfo[];
  total: number;
}

interface IRecommendPageModelsData {
  pageResult: IRecommendPageResult;
  selectAllTotal: {
    modelCount: number;
    collectionCount: number;
    memberCount: number;
  };
  seed: string;
}

// 模型推荐返回数据定义
export interface IResRecommendPageModels {
  code: number;
  data: IRecommendPageModelsData;
  msg: string;
}
